import React from 'react';
import { Card, Title, Text, useMantineTheme } from '@mantine/core';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { TimeSeriesData } from '../../../types/statistics-types';

interface TimeSeriesChartProps {
  data: TimeSeriesData[];
}

export function TimeSeriesChart({ data }: TimeSeriesChartProps) {
  const theme = useMantineTheme();
  
  // Formatta i dati per il grafico
  const chartData = data.map(item => ({
    date: item.date,
    'Nuove Richieste': item.newRequests,
    'Richieste Completate': item.completedRequests,
    'Task in Ritardo': item.overdueTasks
  }));
  
  return (
    <Card withBorder p="md">
      <Title order={3} mb="md">Andamento Temporale</Title>
      <Text size="sm" color="dimmed" mb="xl">
        Visualizzazione dell'andamento delle richieste e dei task negli ultimi 30 giorni
      </Text>
      
      <ResponsiveContainer width="100%" height={400}>
        <LineChart
          data={chartData}
          margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
        >
          <CartesianGrid strokeDasharray="3 3" stroke={theme.colors.gray[3]} />
          <XAxis 
            dataKey="date" 
            tick={{ fill: theme.colors.gray[7] }} 
            tickMargin={10}
            tickFormatter={(value) => {
              const date = new Date(value);
              return `${date.getDate()}/${date.getMonth() + 1}`;
            }}
          />
          <YAxis tick={{ fill: theme.colors.gray[7] }} />
          <Tooltip 
            contentStyle={{ 
              backgroundColor: theme.colors.gray[0],
              borderColor: theme.colors.gray[4],
              borderRadius: theme.radius.sm
            }}
          />
          <Legend wrapperStyle={{ paddingTop: 15 }} />
          <Line 
            type="monotone" 
            dataKey="Nuove Richieste" 
            stroke={theme.colors.blue[5]} 
            strokeWidth={2}
            activeDot={{ r: 6 }} 
          />
          <Line 
            type="monotone" 
            dataKey="Richieste Completate" 
            stroke={theme.colors.green[5]} 
            strokeWidth={2}
          />
          <Line 
            type="monotone" 
            dataKey="Task in Ritardo" 
            stroke={theme.colors.red[5]} 
            strokeWidth={2}
          />
        </LineChart>
      </ResponsiveContainer>
    </Card>
  );
}